import React, { useEffect } from 'react'
import styled from 'styled-components'

const AdvertiseBlock = styled.div`
  text-align: center;
`
type CreativeSize = [number, number]

type Props = { adSlotId: string; size: CreativeSize; adCode: string }

export default function AdManager({ adSlotId, size, adCode }: Props) {
  useEffect(() => {
    window.googletag = window.googletag || {cmd: []};
    googletag.cmd.push(function () {
      googletag.defineSlot(adCode, [size], adSlotId).addService(googletag.pubads());
      googletag.pubads().enableSingleRequest()
      googletag.enableServices()
    })
    googletag.cmd.push(function () { googletag.display(adSlotId) })
  }, [])
  return <AdvertiseBlock id={adSlotId} />
}
